<div class="notification-box">
  <app-svg-icon [icon]="'notification'"></app-svg-icon>
  @if (notifications?.length > 0) {
  <span class="badge rounded-pill badge-secondary">{{ notifications?.length}}</span>
  }
</div>

<div class="onhover-show-div notification-dropdown">
  <h6 class="f-18 mb-0 dropdown-title">{{ "PROPERTIES.Obavijesti" | translate}}</h6>

  <ul>
    @if(showIzmjenaStopa) {
    <li routerLink="/sheme-obracuna">
      <p class="text-left"><i class="fa fa-circle-o me-1 font-primary"></i>
        Izmijeni stope obračuna doprinosa
      </p>
    </li>
    }

    @for (item of notifications; track $index) {
    @if (item.type == 1) {
    <li (click)="getNotification(item.id, 'task')">
      <p class="text-left">
        <i class="fa fa-circle-o me-1 font-danger"></i> {{item.desc}}
        <span class="pull-right"> {{item?.date | date: 'dd.MM.yy HH:mm' }}</span>
      </p>
    </li>
    }
    @else if (item.type == 2) {
    <li (click)="notificationClickedDMS(item.id, item.dms)">
      <p class="text-left">
        <i class="fa fa-circle-o me-1 font-success"></i> {{item.desc}}
        <span class="pull-right"> {{item.date | date: 'dd.MM.yy HH:mm' }}</span>
      </p>
    </li>
    }

    @else if (item.type == 3) {
    <li routerLink="/licence/pred-istek">
      <p class="text-left">
        <i class="fa fa-circle-o me-1 font-warning"></i> {{item.desc}}
        <span class="pull-right"> {{item.date | date: 'dd.MM.yy HH:mm' }}</span>
      </p>
    </li>
    }
    }
  </ul>
</div>